import './loading-styles.css';

function Loading() {

    return (
        <div className="mt-10 mx-auto text-center">
            <img className="mx-auto h-20 w-auto" src="logo_musta.png" alt="Vikke" />
            <h1 className="mt-5 mb-5 text-2xl text-bold text-gray-900">Sivu latautuu</h1>
            <div className="spinner"></div>
        </div>
    );
}

export default Loading;